var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngola(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 256C0 114.616 114.616 0 256 0C397.384 0 512 114.616 512 256C500.87 256 256 289.391 256 289.391L0 256Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 256C512 397.384 397.384 512 256 512C114.616 512 0 397.384 0 256",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.898 203.612L242.6 219.362L234.33 244.87L256.016 229.094L277.72 244.844L269.418 219.344L291.102 203.57L264.287 203.586L255.984 178.087L247.713 203.595L220.898 203.612Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 145.149C299.827 133.502 277.77 128.005 256 128.043V161.427C272.091 161.398 288.393 165.458 303.304 174.068C348.482 200.152 364.017 258.128 337.932 303.306C311.849 348.484 253.874 364.019 208.695 337.935C195.533 330.336 184.908 320.018 177.076 308.111L149.2 326.515C159.797 342.624 174.193 356.571 192 366.851C253.124 402.141 331.561 381.124 366.85 320C402.14 258.876 381.124 180.439 320 145.149V145.149Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.19 233.739C173.34 249.918 179.282 270.209 195.46 279.059L303.909 338.319C296.534 351.8 300.451 368.209 313.932 375.584L343.227 391.609C356.708 398.985 373.619 394.033 380.994 380.551L397.019 351.257L182.19 233.739Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngola);
export default __webpack_public_path__ + "static/media/angola.d687f9245bbb606fde4c6decab38f76b.svg";
export { ForwardRef as ReactComponent };